import { baseStyles } from '../base-styles';

export function getStyles(accent: string, _position: string): string {
  return baseStyles(accent) + `
    .yd-dock-pill {
      position: fixed;
      bottom: 16px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      gap: 8px;
      background: ${accent};
      color: white;
      border: none;
      border-radius: 24px;
      padding: 8px 20px;
      font-size: 13px;
      font-weight: 500;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      cursor: pointer;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      transition: transform 0.2s, box-shadow 0.2s;
      z-index: 1;
      pointer-events: auto;
      white-space: nowrap;
    }
    .yd-dock-pill:hover {
      transform: translateX(-50%) scale(1.05);
      box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
    }

    .yd-dock-panel {
      position: fixed;
      bottom: 60px;
      left: 50%;
      transform: translateX(-50%);
      width: 360px;
      height: 480px;
      max-height: calc(100vh - 80px);
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 16px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      z-index: 1;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      pointer-events: auto;
    }

    @media (max-width: 480px) {
      .yd-dock-panel {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        max-height: 100%;
        border-radius: 0;
        transform: none;
      }
    }

    .yd-dock-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 14px;
      border-bottom: 1px solid #f3f4f6;
    }
    .yd-dock-header-name {
      font-size: 13px;
      font-weight: 500;
      color: #9ca3af;
    }
    .yd-dock-header-actions {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .yd-dock-header-btn {
      background: none;
      border: none;
      color: #9ca3af;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      border-radius: 4px;
      transition: color 0.15s, background 0.15s;
    }
    .yd-dock-header-btn:hover {
      color: #6b7280;
      background: #f3f4f6;
    }

    /* Override base suggestion colors for minimal-dock's lighter look */
    .yd-suggestion {
      background: #f9fafb;
    }
    .yd-suggestion:hover {
      background: #f3f4f6;
    }
  `;
}
